import React from 'react';
import "../../pages/draft/style/medialist.scss";

export default ({
    medias,
    onDeleteMedia
}) => {

  const handleCopyId = (id) => {
    navigator.clipboard.writeText(id).then(() => {
      alert('ID copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy ID:', err);
    });
  };



  return (
      <div className='media-list'>
        <h2>Media List</h2>
        <ul>
          {medias.map(media => (
              <li key={media.id}>

                {media.type === 'AUDIO' && (
                    <audio controls className='audio-preview'>
                      <source src={`/public/api/media/${media.id}`} type="audio/mpeg"/>
                      Your browser does not support the audio element.
                    </audio>
                )}
                {media.type === 'IMAGE' && (
                    <img src={`/public/api/media/${media.id}`} className='image-preview'/>
                )}

                <span>{media.name}</span>

                <button onClick={() => handleCopyId(media.id)} className='copy'>
                  copy ID
                </button>

                <button onClick={() => onDeleteMedia(media.id)} className='delete'>
                  delete
                </button>

              </li>
          ))}
        </ul>
      </div>
  );
};